module.exports = __webpack_public_path__ + "static/img/ex_t6.1db912e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ex_t6.jpg
// module id = XACL
// module chunks = 1